<template>
  <div class="app-container">
    <el-card shadow="never" class="beauty-card">
      <div slot="header" style="display: flex; justify-content: space-between; align-items: center">
        <span style="font-size: 16px; font-weight: bold">{{ $t('batchCreate.title') }} <el-tag type="warning" size="mini">TEST</el-tag></span>
        <div>
          <el-button size="small" @click="$router.go(-1)">{{ $t('batchCreate.cancel') }}</el-button>
          <el-button size="small" type="primary" :loading="submitLoading" @click="handleSubmit">{{ $t('batchCreate.createTask') }}</el-button>
        </div>
      </div>

      <!-- 模板 / 账户 / 公共页 / Pixel -->
      <el-form :inline="true" label-width="80px" style="margin-bottom: 16px">
        <el-form-item :label="$t('batchCreate.selectTemplate')">
          <el-select v-model="templateId" style="width: 300px" :placeholder="$t('batchCreate.selectTemplatePlaceholder')" clearable>
            <el-option v-for="tpl in mockTemplates" :key="tpl.id" :label="tpl.name" :value="tpl.id" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('batchCreate.adAccount')">
          <el-select v-model="selectedAccountIds" multiple style="width: 400px" :placeholder="$t('batchCreate.adAccountPlaceholder')" filterable>
            <el-option v-for="acc in mockAccounts" :key="acc.accountId" :label="acc.accountName + ' (' + acc.accountId + ')'" :value="acc.accountId" />
          </el-select>
        </el-form-item>
      </el-form>
      <el-form :inline="true" label-width="80px" style="margin-bottom: 16px">
        <el-form-item :label="$t('batchCreate.pageId')" required>
          <el-select v-model="pageId" style="width: 380px" :placeholder="$t('batchCreate.pageIdPlaceholder')" filterable>
            <el-option v-for="p in mockPages" :key="p.pageId" :value="p.pageId">
              <span style="float: left">{{ p.pageName }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px; margin-left: 20px">{{ p.pageId }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('batchCreate.pixelId')" required>
          <el-select v-model="pixelId" style="width: 380px" :placeholder="$t('batchCreate.pixelIdPlaceholder')" filterable>
            <el-option v-for="px in mockPixels" :key="px.pixelId" :value="px.pixelId">
              <span style="float: left">{{ px.pixelName }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px; margin-left: 20px">{{ px.pixelId }}</span>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <el-divider content-position="left">{{ $t('batchCreate.campaignConfig') }}</el-divider>

      <!-- 系列列表 -->
      <div v-for="(camp, ci) in campaigns" :key="ci" class="campaign-card">
        <div class="campaign-header">
          <span class="campaign-title">{{ $t('batchCreate.campaignIndex', { index: ci + 1 }) }}</span>
          <el-button v-if="campaigns.length > 1" size="mini" type="danger" @click="removeCampaign(ci)">{{ $t('common.delete') }}</el-button>
        </div>
        <el-form label-width="100px" size="small">
          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item :label="$t('batchCreate.campaignName')">
                <el-input v-model="camp.name" :placeholder="$t('batchCreate.campaignNamePlaceholder')" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('batchCreate.landingPageUrl')">
                <el-input v-model="camp.landingPageUrl" placeholder="https://..." />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('batchCreate.adsetCount')">
                <el-input-number v-model="camp.adsetCount" :min="1" :max="50" size="small" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item :label="$t('batchCreate.adTitle')">
                <el-input v-model="camp.adTitle" :placeholder="$t('batchCreate.adTitlePlaceholder')" />
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item :label="$t('batchCreate.adBody')">
                <el-input v-model="camp.adBody" type="textarea" :rows="2" :placeholder="$t('batchCreate.adBodyPlaceholder')" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item :label="$t('batchCreate.selectMaterial')">
            <el-select v-model="camp.materialIds" multiple filterable style="width: 100%" :placeholder="$t('batchCreate.selectMaterialPlaceholder')">
              <el-option v-for="mat in mockMaterials" :key="mat.id" :label="mat.name" :value="mat.id" />
            </el-select>
          </el-form-item>
        </el-form>
      </div>

      <el-button type="dashed" icon="el-icon-plus" style="width: 100%; margin-top: 12px" @click="addCampaign">{{ $t('batchCreate.addCampaign') }}</el-button>
    </el-card>

    <!-- 右侧预览 -->
    <el-card shadow="never" class="beauty-card preview-card" style="margin-top: 12px">
      <div slot="header"><b>{{ $t('batchCreate.previewTitle') }}</b></div>
      <div class="preview-summary">
        <p><b style="color: #E6A23C">{{ $t('batchCreate.selectedAssets') }}</b></p>
        <p>{{ $t('batchCreate.summaryAssets', { accounts: selectedAccountIds.length, materials: totalMaterials, campaigns: campaigns.length }) }}</p>
        <p style="margin-top: 8px"><b style="color: #E6A23C">{{ $t('batchCreate.publishTotal') }}</b></p>
        <p>{{ $t('batchCreate.summaryPublish', { campaigns: campaigns.length, adsets: totalAdsets, ads: totalAds }) }}</p>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'BatchCreateTest',
  data() {
    return {
      submitLoading: false,
      templateId: null,
      selectedAccountIds: [],
      pageId: '',
      pixelId: '',
      campaigns: [this.newCampaign()],

      // ===== Mock data (all in English) =====
      mockTemplates: [
        { id: 1, name: 'Standard Sales Template' },
        { id: 2, name: 'Traffic Boost Template' },
        { id: 3, name: 'Engagement Campaign Template' }
      ],
      mockAccounts: [
        { accountId: 'act_1031102532429385', accountName: 'LT4-07' },
        { accountId: 'act_2847193056281749', accountName: 'US-Main-Store' },
        { accountId: 'act_5019283746501827', accountName: 'EU-Fashion-01' },
        { accountId: 'act_7382910465382910', accountName: 'JP-Electronics' },
        { accountId: 'act_9127384650192837', accountName: 'CA-Beauty-Lab' }
      ],
      mockPages: [
        { pageId: '122104157744003566', pageName: 'Davis Tilley Caroline' },
        { pageId: '122104119074003083', pageName: 'Bryce Jack Lana' },
        { pageId: '122104115912003147', pageName: 'Tristan Raegan' },
        { pageId: '122104215458002798', pageName: 'Ball Wynn Sam' },
        { pageId: '122104213052003463', pageName: 'Awtry Lauren Kev' },
        { pageId: '122104174382003740', pageName: 'Kay Kay Callahan' },
        { pageId: '122104160390002553', pageName: 'Nya Lee Juan' },
        { pageId: '122104154018002892', pageName: 'Chrissy Stumpf Kendra' }
      ],
      mockPixels: [
        { pixelId: '1225341705656796', pixelName: 'WJ-LT3-New' },
        { pixelId: '875803851543513', pixelName: 'WJ-YH15' },
        { pixelId: '1233713928564967', pixelName: 'pixel-002' },
        { pixelId: '1353056339532389', pixelName: 'MY-pixel-001' },
        { pixelId: '813621467743327', pixelName: 'WJ-pixel-001' },
        { pixelId: '228203414242787', pixelName: 'LT3-deprecated' },
        { pixelId: '179180149477293', pixelName: 'LT3-youtang-15.99' },
        { pixelId: '772052069081350', pixelName: 'LT3-youtang-19.99' }
      ],
      mockMaterials: [
        { id: 1001, name: 'summer-sale-banner-01.jpg' },
        { id: 1002, name: 'product-showcase-video.mp4' },
        { id: 1003, name: 'lifestyle-blue-dress.jpg' },
        { id: 1004, name: 'unboxing-review-15s.mp4' },
        { id: 1005, name: 'new-arrival-carousel-01.jpg' },
        { id: 1006, name: 'flash-deal-countdown.mp4' },
        { id: 1007, name: 'customer-testimonial-30s.mp4' },
        { id: 1008, name: 'brand-logo-square.png' }
      ]
    };
  },
  computed: {
    totalMaterials() {
      const ids = new Set();
      this.campaigns.forEach(c => (c.materialIds || []).forEach(id => ids.add(id)));
      return ids.size;
    },
    totalAdsets() {
      return this.campaigns.reduce((sum, c) => sum + (c.adsetCount || 1), 0) * this.selectedAccountIds.length;
    },
    totalAds() {
      return this.campaigns.reduce((sum, c) => {
        const mats = (c.materialIds || []).length || 1;
        return sum + (c.adsetCount || 1) * mats;
      }, 0) * this.selectedAccountIds.length;
    }
  },
  methods: {
    newCampaign() {
      return {
        name: '',
        landingPageUrl: '',
        adTitle: '',
        adBody: '',
        adsetCount: 5,
        materialIds: [],
        adsets: []
      };
    },
    addCampaign() {
      this.campaigns.push(this.newCampaign());
    },
    removeCampaign(idx) {
      this.campaigns.splice(idx, 1);
    },

    /** 测试模式：不调用后端API，直接前端返回成功 */
    handleSubmit() {
      if (this.selectedAccountIds.length === 0) {
        this.$message.warning(this.$t('batchCreate.accountRequired'));
        return;
      }
      if (this.campaigns.length === 0) {
        this.$message.warning(this.$t('batchCreate.campaignRequired'));
        return;
      }
      for (let i = 0; i < this.campaigns.length; i++) {
        if (!this.campaigns[i].name) {
          this.$message.warning(this.$t('batchCreate.campaignNameRequired', { index: i + 1 }));
          return;
        }
      }

      this.$confirm(this.$t('batchCreate.confirmMsg', { count: this.totalAds }), this.$t('batchCreate.confirmTitle'), {
        confirmButtonText: this.$t('batchCreate.confirmBtn'),
        cancelButtonText: this.$t('batchCreate.cancel'),
        type: 'info'
      }).then(() => {
        this.submitLoading = true;
        // 模拟 1 秒延迟后直接返回成功 — 不调用任何 API
        setTimeout(() => {
          this.submitLoading = false;
          this.$message.success(this.$t('batchCreate.successMsg', { success: this.totalAds, fail: 0 }));
        }, 1000);
      }).catch(() => {});
    }
  }
};
</script>

<style scoped>
.campaign-card {
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 12px;
  position: relative;
}
.campaign-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.campaign-title {
  font-size: 14px;
  font-weight: bold;
  color: #409EFF;
}
.preview-card {
  background: #FFF9EC;
}
.preview-summary p {
  margin: 4px 0;
  font-size: 13px;
  color: #606266;
}
</style>
